/* ==============================================================================================
 * [ACCESS] NEW ISSUES CALENDAR TABLE
 * ============================================================================================== */

var Sushi, CGS;

var setupNewIssuesCalendarChildTables;

(function (Sushi, CGS) {
	"use strict";

	// TODO: Update API endpoint URLs
	var issuersApiEndpoint = "/json/access/newIssues.json";
	var issuesApiEndpoint = "/json/access/issuerResultsIssues.json";

	var issuerTableElement = document.querySelector("#newIssuesCalendarTable");

	if (!issuerTableElement) {
		return;
	}

	var issuersTableColumns = [
		{
			data: "issuerDatedDate",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "issuerName",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: null,
			orderable: false,
			className: "c-table__cell c-table__cell--expand",
			defaultContent: "",
		},
	];

	var issuersTableColumnDefs = [
		{
			targets: [ 1 ],
			render: function (data) {
				return "<a data-plugin='IssuerDetail' "
					+ "href='#' "
					+ "data-issuer-number='" + data + "' "
					+ ">" + data + "</a>";
			},
		},
		{
			targets: [ 2 ],
			orderable: false,
		},
	];

	var getIssuesTable = function () {
		return CGS.createTableHtml({
			files: true,
			head: {
				rows: [{
					cells: [
						{ content: "" },
						{ content: "Issue Description" },
						{ content: "Dated date" },
						{ content: "Maturity" },
						{ content: "Coupon" },
						{ content: "CUSIP" },
					],
				}],
			},
		});
	};

	CGS.table(issuerTableElement, {
		ajax: issuersApiEndpoint,
		columns: issuersTableColumns,
		columnDefs: issuersTableColumnDefs,
		createdRow: function (row) {
			row.classList.add("c-table__row--expand");
		},
		initComplete: function (settings, json) {
			/**
			 * Workaround to setup child tables after the table is reloaded, as the `initComplete`
			 * method is not exposed through DataTables api.
			 *
			 * @see https://datatables.net/forums/discussion/comment/61140/#Comment_61140
			 */
			setupNewIssuesCalendarChildTables = function (newEndpoint) {
				CGS.setupChildTables(settings, json, {
					ajax: {
						url: newEndpoint || issuesApiEndpoint,
						dataSrc: "issueList",
					},
					columns: CGS.getNewIssuesTableColumns(),
					columnDefs: CGS.getNewIssuesTableColumnDefs(),
					tableFn: getIssuesTable,
				});
			};

			setupNewIssuesCalendarChildTables();
		},
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
